import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

import { FormGroup } from 'components/bootstrap';
import useDataLakeTableOptions from 'data-lake/preview/storage-types/external/hooks/useDataLakeTableOptions';
import useSelectedDataLake from 'data-lake/hooks/useSelectedDataLake';
import { Select } from 'components/common';
import StyledLabel from 'data-lake/components/DataLakeActionModals/StyledLabel';

const Container = styled(FormGroup)`
  flex: 1;
  grid-area: table;
`;

const placeholder = 'Select the table you want to preview logs for';

const TableFilter = () => {
  const { selectedDataLake } = useSelectedDataLake();
  const { data, isLoading } = useDataLakeTableOptions(selectedDataLake?.id);

  return (
    <>
      <StyledLabel>Table:</StyledLabel>
      <Field name="streamIds">
        {({ field: { value, onChange, name }, meta: { error } }) => (
          <Container data-testid="streamIds-filter" validationState={error ? 'error' : undefined} bsClass="no-bm">
            <Select
              placeholder={placeholder}
              displayKey="key"
              inputId="streamIds-filter"
              value={value?.[0]}
              options={data}
              multi={false}
              onChange={(newVal) => {
                onChange({ target: { value: [newVal], name } });
              }}
              isLoading={isLoading}
            />
          </Container>
        )}
      </Field>
    </>
  );
};

export default TableFilter;
